(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-ninja"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const colorOptions = document.querySelectorAll('.color-option');
    const variantSelect = document.getElementById('variant-select');
    const selectedColorText = document.getElementById('selected-color');
    const submitButtons = document.querySelectorAll('[data-product-submit]');
    const availability = document.querySelector('[data-product-availability]');
    const availabilityStatus = availability ? availability.querySelector('[data-product-availability-status]') : null;
    const availabilityDelivery = availability ? availability.querySelector('[data-product-availability-delivery]') : null;
    const availabilityShipping = availability ? availability.querySelector('[data-product-availability-shipping]') : null;
    const mobileBuybarButtonGlobal = document.querySelector('[data-mobile-buybar-submit]');

    function updateWaitlists(isAvailable) {
      document.querySelectorAll('[data-waitlist-slot]').forEach(slot => {
        const location = slot.dataset.waitlistSlot;
        if (isAvailable) {
          slot.querySelectorAll('[data-waitlist-form]').forEach(form => form.remove());
          return;
        }
        if (slot.querySelector('[data-waitlist-form]')) return;
        const template = document.querySelector(`[data-waitlist-template="${location}"]`);
        if (template) slot.appendChild(template.content.cloneNode(true));
      });
    }

    function updateProductAvailability(isAvailable) {
      submitButtons.forEach(button => {
        button.disabled = !isAvailable;
        button.setAttribute('aria-disabled', String(!isAvailable));
        button.textContent = isAvailable ? button.dataset.availableText : button.dataset.soldOutText;
      });

      if (availability) {
        availability.dataset.productAvailable = String(isAvailable);
        availability.classList.toggle('product-hero__availability--available', isAvailable);
        availability.classList.toggle('product-hero__availability--unavailable', !isAvailable);
      }
      if (availabilityStatus) availabilityStatus.textContent = isAvailable ? 'Auf Lager' : 'Aktuell nicht auf Lager';
      if (availabilityDelivery) availabilityDelivery.hidden = !isAvailable;
      if (availabilityShipping) availabilityShipping.hidden = !isAvailable;
      updateWaitlists(isAvailable);

      if (mobileBuybarButtonGlobal) {
        mobileBuybarButtonGlobal.dataset.productAvailable = String(isAvailable);
        mobileBuybarButtonGlobal.textContent = isAvailable
          ? mobileBuybarButtonGlobal.dataset.availableText
          : mobileBuybarButtonGlobal.dataset.soldOutText;
        mobileBuybarButtonGlobal.type = isAvailable ? 'submit' : 'button';
        if (isAvailable) {
          mobileBuybarButtonGlobal.setAttribute('form', 'product-form');
        } else {
          mobileBuybarButtonGlobal.removeAttribute('form');
        }
      }
    }

    colorOptions.forEach(option => {
      option.addEventListener('click', function() {
        const variantId = this.dataset.variantId;
        const variantTitle = this.dataset.variantTitle;
        const variantAvailable = this.dataset.variantAvailable === 'true';

        colorOptions.forEach(opt => opt.classList.remove('selected'));
        this.classList.add('selected');

        if (variantSelect) variantSelect.value = variantId;
        if (selectedColorText) selectedColorText.textContent = variantTitle;

        updateProductAvailability(variantAvailable);
        const variantImage = this.querySelector('[data-variant-image]');
        if (variantImage) {
          setMainImage(variantImage.content.querySelector('img'));
          thumbnails.forEach(thumb => {
            const imageData = thumb.querySelector('[data-main-image]')?.content.querySelector('img');
            thumb.classList.toggle('active', imageData?.getAttribute('src') === variantImage.content.querySelector('img')?.getAttribute('src'));
          });
        }
      });
    });

    const selectedColorOption = document.querySelector('.color-option.selected');
    const initialAvailability = selectedColorOption
      ? selectedColorOption.dataset.variantAvailable === 'true'
      : availability && availability.dataset.productAvailable === 'true';
    updateProductAvailability(Boolean(initialAvailability));

    const thumbnails = document.querySelectorAll('.product-images__thumb');
    const mainImage = document.querySelector('.product-images__main img');
    const heroMain = document.querySelector('.product-images__main');
    const heroImage = document.querySelector('.product-images__main-image');
    const pageRoot = document.querySelector('.product-page');
    const productTheater = document.querySelector('[data-product-theater]');
    const productTheaterImage = productTheater ? productTheater.querySelector('.product-theater__image') : null;

    function setMainImage(imageData) {
      if (!mainImage || !imageData) return;
      ['srcset', 'sizes', 'src', 'alt'].forEach(attribute => {
        const value = imageData.getAttribute(attribute);
        if (value === null) mainImage.removeAttribute(attribute);
        else mainImage.setAttribute(attribute, value);
      });
    }

    thumbnails.forEach(thumb => {
      thumb.addEventListener('click', function() {
        const imageData = this.querySelector('[data-main-image]')?.content.querySelector('img');
        if (mainImage && imageData) {
          setMainImage(imageData);
          thumbnails.forEach(t => t.classList.remove('active'));
          this.classList.add('active');
        }
      });
    });

    if (heroMain && heroImage && window.matchMedia('(pointer: fine)').matches) {
      heroMain.addEventListener('mousemove', (event) => {
        const rect = heroMain.getBoundingClientRect();
        const x = ((event.clientX - rect.left) / rect.width - 0.5) * 8;
        const y = ((event.clientY - rect.top) / rect.height - 0.5) * 10;
        heroImage.style.setProperty('--hero-shift-x', `${x}px`);
        heroImage.style.setProperty('--hero-shift-y', `${y}px`);
        heroImage.style.setProperty('--hero-rotate-x', `${-y * 0.32}deg`);
        heroImage.style.setProperty('--hero-rotate-y', `${x * 0.34}deg`);
        if (pageRoot) {
          pageRoot.style.setProperty('--hero-glow-x', `${((event.clientX - rect.left) / rect.width) * 100}%`);
          pageRoot.style.setProperty('--hero-glow-y', `${((event.clientY - rect.top) / rect.height) * 100}%`);
        }
        heroMain.style.boxShadow = `0 ${72 + (y * 1.1)}px 140px rgba(0,0,0,0.34)`;
      });

      heroMain.addEventListener('mouseleave', () => {
        heroImage.style.setProperty('--hero-shift-x', '0px');
        heroImage.style.setProperty('--hero-shift-y', '0px');
        heroImage.style.setProperty('--hero-rotate-x', '0deg');
        heroImage.style.setProperty('--hero-rotate-y', '0deg');
        if (pageRoot) {
          pageRoot.style.setProperty('--hero-glow-x', '50%');
          pageRoot.style.setProperty('--hero-glow-y', '30%');
        }
        heroMain.style.boxShadow = '';
      });
    }

    if (productTheater && productTheaterImage && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      let theaterFrame = null;
      const updateTheater = () => {
        theaterFrame = null;
        const rect = productTheater.getBoundingClientRect();
        const viewport = window.innerHeight || document.documentElement.clientHeight;
        const progress = Math.max(-1, Math.min(1, ((rect.top + rect.height / 2) - viewport / 2) / viewport));
        productTheaterImage.style.setProperty('--theater-y', `${progress * -18}px`);
      };
      const requestTheater = () => {
        if (theaterFrame) return;
        theaterFrame = window.requestAnimationFrame(updateTheater);
      };
      updateTheater();
      window.addEventListener('scroll', requestTheater, { passive: true });
      window.addEventListener('resize', requestTheater);
    }

    const revealTargets = Array.from(new Set([
      ...document.querySelectorAll('.product-page .product-section:not(.product-hero)'),
      ...document.querySelectorAll('[data-reveal]')
    ]));
    if (revealTargets.length) {
      if ('IntersectionObserver' in window) {
        const revealObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              revealObserver.unobserve(entry.target);
            }
          });
        }, { threshold: 0.16, rootMargin: '0px 0px -8% 0px' });

        revealTargets.forEach((element, index) => {
          element.style.transitionDelay = `${Math.min(index * 90, 360)}ms`;
          revealObserver.observe(element);
        });
      } else {
        revealTargets.forEach((element) => element.classList.add('is-visible'));
      }
    }

    const story = document.querySelector('.product-story__experience');
    const storySection = document.querySelector('.product-story');
    const storyTabs = Array.from(document.querySelectorAll('[data-story-tab]'));
    if (story && storySection && storyTabs.length) {
      let storyCycle = null;
      let storySequenceTimeout = null;
      const storyStates = ['werbung', 'tracker', 'riskant'];
      const storyPhases = [
        { name: 'incoming', delay: 0 },
        { name: 'converge', delay: 980 },
        { name: 'filter', delay: 2120 },
        { name: 'clear', delay: 3340 },
        { name: 'settle', delay: 4560 }
      ];

      const setStoryState = (state) => {
        story.dataset.storyState = state;
        storyTabs.forEach((tab) => {
          const active = tab.dataset.storyTab === state;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      };

      const clearStorySequence = () => {
        if (storySequenceTimeout) {
          window.clearTimeout(storySequenceTimeout);
          storySequenceTimeout = null;
        }
      };

      const setStoryPhase = (phase) => {
        story.dataset.storyPhase = phase;
      };

      const runStorySequence = (state) => {
        clearStorySequence();
        setStoryState(state);
        setStoryPhase('incoming');

        let stepIndex = 0;
        const step = () => {
          const current = storyPhases[stepIndex];
          if (!current) return;
          setStoryPhase(current.name);
          stepIndex += 1;
          if (stepIndex < storyPhases.length) {
            const nextDelay = storyPhases[stepIndex].delay - current.delay;
            storySequenceTimeout = window.setTimeout(step, nextDelay);
          }
        };

        step();
      };

      const startStoryCycle = (initialState = null) => {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          setStoryState(initialState || story.dataset.storyState || storyStates[0]);
          setStoryPhase('settle');
          return;
        }
        if (storyCycle) window.clearInterval(storyCycle);
        let index = storyStates.indexOf(initialState || story.dataset.storyState);
        if (index < 0) index = 0;
        runStorySequence(storyStates[index]);
        storyCycle = window.setInterval(() => {
          index = (index + 1) % storyStates.length;
          runStorySequence(storyStates[index]);
        }, 6200);
      };

      storyTabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          startStoryCycle(tab.dataset.storyTab);
        });
      });

      if ('IntersectionObserver' in window) {
        const storyObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              storySection.classList.add('is-story-active');
              startStoryCycle();
            } else {
              if (storyCycle) {
                window.clearInterval(storyCycle);
                storyCycle = null;
              }
              clearStorySequence();
            }
          });
        }, { threshold: 0.45 });

        storyObserver.observe(storySection);
      } else {
        runStorySequence(story.dataset.storyState || storyStates[0]);
      }
    }

    const appSection = document.querySelector('.product-app');
    const appSlider = appSection ? appSection.querySelector('[data-app-slider]') : null;
    if (appSlider) {
      const track = appSlider.querySelector('.product-app__track');
      const slides = Array.from(appSlider.querySelectorAll('.product-app__slide'));
      const prev = appSlider.querySelector('.product-app__nav--prev');
      const next = appSlider.querySelector('.product-app__nav--next');
      const dots = appSection ? Array.from(appSection.querySelectorAll('.product-app__dot')) : [];
      let currentIndex = 0;
      let touchStartX = 0;
      let touchEndX = 0;

      const updateSlider = () => {
        if (!track || slides.length === 0) return;
        track.style.transform = `translateX(-${currentIndex * 100}%)`;
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === currentIndex));
        slides.forEach((slide, i) => slide.classList.toggle('is-active', i === currentIndex));
      };

      const goTo = (index) => {
        currentIndex = (index + slides.length) % slides.length;
        updateSlider();
      };

      if (prev) prev.addEventListener('click', () => goTo(currentIndex - 1));
      if (next) next.addEventListener('click', () => goTo(currentIndex + 1));
      dots.forEach((dot, index) => dot.addEventListener('click', () => goTo(index)));

      track.addEventListener('touchstart', (event) => {
        touchStartX = event.changedTouches[0].clientX;
      }, { passive: true });

      track.addEventListener('touchend', (event) => {
        touchEndX = event.changedTouches[0].clientX;
        const delta = touchEndX - touchStartX;
        if (Math.abs(delta) < 40) return;
        if (delta < 0) goTo(currentIndex + 1);
        if (delta > 0) goTo(currentIndex - 1);
      }, { passive: true });

      updateSlider();
    }

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    const mobileBuybar = document.querySelector('[data-product-mobile-buybar]');
    if (mobileBuybar) {
      const purchaseBox = document.querySelector('.product-hero__content-card');
      const finalCta = document.querySelector('.product-final-cta');
      const footer = document.querySelector('.footer');
      const mobileBuybarButton = mobileBuybar.querySelector('[data-mobile-buybar-submit]');
      const productForm = document.getElementById('product-form');
      let purchaseBoxInView = true;
      let finalCtaInView = false;
      let footerInView = false;
      let consentInView = false;

      const consentSelectors = [
        '#shopify-pc__banner',
        '.shopify-pc__banner__dialog',
        '[data-shopify-customer-privacy-banner]',
        '.shopify-customer-privacy-banner',
        'iframe[src*="privacy"]'
      ];

      const updateConsentState = () => {
        consentInView = consentSelectors.some((selector) => {
          const element = document.querySelector(selector);
          if (!element) return false;
          const style = window.getComputedStyle(element);
          const rect = element.getBoundingClientRect();
          return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0;
        });
      };

      const updateMobileBuybar = () => {
        updateConsentState();
        mobileBuybar.classList.toggle(
          'is-visible',
          !purchaseBoxInView && !finalCtaInView && !footerInView && !consentInView
        );
      };

      if ('IntersectionObserver' in window && purchaseBox) {
        const purchaseObserver = new IntersectionObserver((entries) => {
          const entry = entries[0];
          purchaseBoxInView = entry.isIntersecting;
          updateMobileBuybar();
        }, { threshold: 0.01 });
        purchaseObserver.observe(purchaseBox);
      } else {
        purchaseBoxInView = window.scrollY < 520;
        updateMobileBuybar();
        window.addEventListener('scroll', () => {
          purchaseBoxInView = window.scrollY < 520;
          updateMobileBuybar();
        }, { passive: true });
      }

      if ('IntersectionObserver' in window) {
        const closingObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.target === finalCta) finalCtaInView = entry.isIntersecting;
            if (entry.target === footer) footerInView = entry.isIntersecting;
          });
          updateMobileBuybar();
        }, { threshold: 0.01 });
        if (finalCta) closingObserver.observe(finalCta);
        if (footer) closingObserver.observe(footer);
      }

      if (mobileBuybarButton) {
        mobileBuybarButton.addEventListener('click', (event) => {
          event.preventDefault();
          const isAvailable = mobileBuybarButton.dataset.productAvailable === 'true';
          if (!isAvailable) {
            const waitlist = document.querySelector('[data-waitlist-slot="hero"] [data-waitlist-form]');
            const emailInput = waitlist ? waitlist.querySelector('input[type="email"]') : null;
            if (waitlist) waitlist.scrollIntoView({ behavior: 'smooth', block: 'center' });
            if (emailInput) window.setTimeout(() => emailInput.focus({ preventScroll: true }), prefersReducedMotion ? 0 : 450);
            return;
          }
          if (productForm && typeof productForm.requestSubmit === 'function') {
            productForm.requestSubmit();
          } else if (productForm) {
            productForm.submit();
          }
        });
      }

      const consentObserver = new MutationObserver(updateMobileBuybar);
      consentObserver.observe(document.body, { childList: true, subtree: true, attributes: true });
      updateMobileBuybar();
    }

    const setupMobileRail = (selector, cardSelector, intervalMs) => {
      if (!isMobile || prefersReducedMotion) return;
      const rail = document.querySelector(selector);
      if (!rail) return;
      const cards = Array.from(rail.querySelectorAll(cardSelector));
      if (cards.length < 2) return;
      let index = 0;
      const go = () => {
        index = (index + 1) % cards.length;
        rail.scrollTo({ left: cards[index].offsetLeft - rail.offsetLeft, behavior: 'smooth' });
      };
      let timer = window.setInterval(go, intervalMs);
      rail.addEventListener('pointerdown', () => window.clearInterval(timer), { once: true });
      rail.addEventListener('touchstart', () => window.clearInterval(timer), { once: true, passive: true });
    };

    setupMobileRail('.product-hardware__grid', '.product-hardware__card', 4200);
    setupMobileRail('.product-reviews__grid', '.product-review', 5200);
  });

  } catch(e) { console.error(e); }
})();
})();
